module.exports = __webpack_public_path__ + "static/logo-full-9fe44da305b25fcbb9448f92b5776e4b.svg";